export interface Position {
  id: string;
  ticker: string;
  buyPrice: number;
  quantity: number;
  currentPrice?: number;
  lastUpdated?: Date;
  totalValue?: number;
  localCurrency?: string;
  gainPct?: number;
  addedValueChf?: number;
  pricePerShare?: number;
  isin?: string;
  stockCode?: string; // Translated from ISIN
  initialInvestment?: number;
}

export interface SellTier {
  gainPct: number;              // Gain threshold (15%, 30%, 45%)
  recoverPct: number;           // Additional % to recover at this tier
  cumulativeRecoverPct: number; // Total % of capital recovered
  sellQtyPct?: number;          // Direct percentage of shares to sell (overrides recovery calculation)
}

export interface AlertLevel {
  type: 'profit' | 'warning' | 'danger' | 'hold';
  color: string;
  label: string;
  action: string;
}

export interface ProfitTarget {
  ratio: string;           // e.g., "3:1", "4:1"
  targetPrice: number;
  targetGainPct: number;
  partialSellQty?: number; // For partial profit-taking
}

export interface StopLoss {
  type: 'percentage' | 'technical' | 'ma20' | 'ma50';
  price: number;
  description: string;
}

export interface PositionAnalysis extends Position {
  currentPrice: number;
  gainPct: number;
  gainAmount: number;
  recommendedSellQty: number;
  recommendedSellPct: number;
  totalValue: number;
  totalValueCHF?: number;
  investedValue: number;
  capitalRecovered?: number;        // Amount of capital recovered in local currency
  capitalRecoveredCHF?: number;     // Amount of capital recovered in CHF
  capitalRecoveredPct?: number;     // Percentage of capital recovered
  remainingCapitalAtRisk?: number;  // Capital still at risk in local currency
  // Alert & Trading Strategy
  alertLevel?: AlertLevel;
  profitTargets?: ProfitTarget[];
  stopLoss?: StopLoss[];
  actionRecommendation?: string;
  riskRewardRatio?: string;
}

export const DEFAULT_SELL_TIERS: SellTier[] = [
  { gainPct: 15, recoverPct: 20, cumulativeRecoverPct: 20 },
  { gainPct: 30, recoverPct: 20, cumulativeRecoverPct: 40 },
  { gainPct: 45, recoverPct: 60, cumulativeRecoverPct: 100, sellQtyPct: 50 }
];
